<template>
  <div class="serveDetail">
    <!-- 下载弹框 -->
    <div
      class="download-shade"
      @click="
        () => {
          downloadShade = false;
        }
      "
      v-show="downloadShade"
    >
      <div class="download-wrap" @click.stop="() => {}">
        <div class="download-wrap-txt" v-show="downloadNum > 0">
          每人可免费下载<span style="color: #3476C1; font-size: 14px"> 2 </span
          >份项目企划书,本次下载将失去<span style="color: #3476C1; font-size: 14px"> 1 </span
          >次，
        </div>
        <div
          class="download-wrap-txt"
          style="color: #333333; margin-top: 14px"
          v-show="downloadNum > 0"
        >
        免费机会是否确定下载？
        </div>
        <div
          class="download-wrap-txt"
          style="margin-top: 8px"
          v-show="downloadNum < 1"
        >
          您免费下载机会已用完,是否使用<span style="color:#3476C1;">{{ needIntegral }}</span>个积分下载项目？
        </div>
        <div
          style="
            width: 220px;
            height: 36px;
            position: absolute;
            left:115px;
            bottom:60px
          "
        >
          <div class="download-wrap-btn-l" @click="downloadShade = false">
            取消
          </div>
          <div class="download-wrap-btn-r" @click="btnFn()">确定</div>
        </div>
        <div
          style="
            width: 100px;
            height: 36px;
            position: absolute;
            left:320px;
            bottom:-6px;
            color:#3476C1;
            font-size:12px;
            font-family: MicrosoftYaHei;
            cursor: pointer;
          "
          v-show="downloadNum < 1"
        >
          如何获取积分？
        </div>
      </div>
    </div>

    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <!-- 面包屑导航 -->
    <div style="width: 1200px; margin: 0 auto">
      <div class="crumbs">
        <span>当前位置：</span>
        <span @click="toHome">首页 ></span>
        <span @click="toProject">项目库 ></span>
        <span style="color: #333333">{{ data.name }}</span>
      </div>
    </div>

    <!-- <div class="crumbs">
            <span>当前位置：</span>
            <span>首页</span>
            <span @click="toProject">项目库 ></span>
            <span>项目详情</span>
        </div> -->
    <div class="head">
      <img :src="data.projectImg" />
      <div class="text">
        <div class="text-b">{{ data.name }}</div>
        <div class="text-s">
          <span
            >公司名称：<span>{{ data.companyName }}</span></span
          >
          <span
            >地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：<span>{{
              data.address
            }}</span></span
          >
          <span
            >行&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：<span>{{
              data.industryName
            }}</span></span
          >
          <span
            >联系电话：<span>{{ data.phoneNum }}</span></span
          >
          <!-- <span>费&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用：<span class="money">{{data.money}}</span><span> 元</span></span> -->
        </div>
        <button class="btn1" @click="downloadFn">下载</button>
        <button @click="collectFn">收藏</button>
      </div>
    </div>
    <div class="serveDetails">
      <div class="blueLine"></div>
      <div class="serveDetailsCH">项目详情</div>
      <div class="serveDetailsEN">Project details</div>
      <div class="article" ref="remark">
        {{ data.remark }}
      </div>
      <div style="clear: both"></div>
    </div>
    <div style="width: 100%; height: 100px"></div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

export default {
  name: "serveDetail",
  components: {
    navigation,
  },
  data() {
    return {
      dialogVisible: false,
      data: {},
      needIntegral: "", //所需要积分
      downloadNum: "", //免费下载次数
      downloadShade: false, //下载弹框
    };
  },
  methods: {
    toHome() {
      sessionStorage.setItem("tabIndex", 1);
      this.$router.push("/");
    },
    toProject() {
      this.$router.push("/project");
    },
    // toServeList(){
    //     this.$router.push('/serveList')
    // },
    // toServeDetail(){
    //     this.$router.push('/serveDetail')
    // }
    //下载按钮
    downloadFn() {
      // this.dialogVisible = true;
      this.downloadShade = true;
      // 项目下载前校验 获取下载次数 和所需要积分
      let projectLibraryId = this.$route.query.id;
      this.$axios
        .post("/v1/cloud/user/project/download/validator", {
          projectLibraryId,
        })
        .then(({ data }) => {
          if (data) {
            this.needIntegral = data.needIntegral; //所需要积分
            this.downloadNum = data.downloadNum; //免费下载次数
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
          // this.$Message.error(error.response.data.message);
        });
    },
    //下载弹框确认按钮
    btnFn() {
      // this.dialogVisible = false;
      this.downloadShade = false;
      //下载
      let projectDatabaseId = this.$route.query.id;
      this.$axios
        .post("/v1/cloud/user/project/download", {
          projectDatabaseId: 1,
        })
        .then(({ data }) => {
          console.log(44, data);

          window.open(data, "_blank");
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },

    //收藏按钮
    collectFn() {
      let projectLibraryId = this.$route.query.id;
      this.$axios
        .post("/v1/cloud/user/project/collection", {
          projectLibraryId,
        })
        .then(({ data }) => {
          if (data === true) {
            this.$Message.success("收藏成功！");
          } else if (data === false) {
            this.$Message.error("收藏失败！");
          }
        })
        .catch((error) => {
          // this.$message({
          //     message: error.response.data.message,
          //     type: 'warning'
          // });
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          }
        });
    },
    outoHeightFn() {},
  },
  created() {
    let projectDatabaseId = this.$route.query.id;
    //项目详情
    this.$axios
      .post("/v1/cloud/common/project-library/details", {
        projectLibraryId:projectDatabaseId,
      })
      .then(({ data }) => {
        if (data) {
          this.data = data;
        }
      })
      .catch((error) => {
        this.$Message.error(error.response.data.message);
      });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
    //内容详情高度样式适配
    this.outoHeightFn();
  },
};
</script>

<style scoped lang="less">
//下载弹框
.download-shade {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  z-index: 44;
  background: rgba(0, 0, 0, 0.5);
  .download-wrap {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;
    width: 450px;
    height: 248px;
    background: rgba(255, 255, 255, 1);
    padding: 50px;
    box-sizing: border-box;
    .download-wrap-txt {
      width: 100%;
      text-align: center;
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333;
    }
    .download-wrap-btn-l {
      width: 80px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #E5E5E5;
      cursor: pointer;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #666666;
      float: left;
      border-radius: 3px;
      
    }
    .download-wrap-btn-r {
      width: 80px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #3476C1;
      cursor: pointer;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #FFFFFF;
      float: right;
      border-radius: 3px;
    }
  }
}
.serveDetail {
  width: 100%;
  background-color: #f5f5f5;
  .crumbs {
    width: 500px;
    font-size: 14px;
    margin-top: 20px;
    span {
      float: left;
      font-style: 12px;
      cursor: pointer;
      margin-left: 5px;
      color: #666666;
    }
  }
  .head {
    width: 1200px;
    height: 340px;
    margin: 60px auto 0;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    img {
      width: 400px;
      height: 300px;
      float: left;
    }
    .text {
      width: 680px;
      float: left;
      margin-left: 40px;
      font-family: MicrosoftYaHei;
      .text-b {
        font-size: 24px;
        font-family: MicrosoftYaHei;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        margin-bottom: 10px;
      }
      .text-s {
        // width: 700px;
        > span {
          display: block;
          font-size: 16px;
          color: #999999;
          margin-top: 10px;
          span {
            color: #333333;
          }
          .money {
            font-size: 24px;
            color: #fd6114;
          }
        }
      }
      button {
        width: 140px;
        height: 40px;
        border: 1px solid #3476c1;
        background: #fff;
        font-family: MicrosoftYaHei;
        outline: none;
        font-weight: 400;
        margin-top: 75px;
        margin-right: 30px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 400;
        color: #3476c1;
        line-height: 40px;
        cursor: pointer;
        text-indent: 67px;
        text-align: left;
        background-image: url("../../static/project/wjxicon.png");
        background-repeat: no-repeat;
        background-size: 18px 18px;
        background-position: 40px 12px;
      }
      .btn1 {
        background-image: url("../../static/project/downloadicon.png");
      }
    }
  }
  .serveDetails {
    // height: 1000px;
    height: auto;
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    padding: 30px 70px 70px 20px;
    padding-top: 40px;
    background-color: #fff;
    .blueLine {
      width: 4px;
      height: 20px;
      background: rgba(15, 155, 241, 1);
      float: left;
      margin-top: 7px;
    }
    .serveDetailsCH {
      float: left;
      // width:78px;
      // height:19px;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      font-weight: 500;
      color: #333;
      margin-left: 10px;
      line-height: 38px;
    }
    .serveDetailsEN {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(101, 101, 101, 1);
      float: left;
      margin-left: 10px;
      margin-top: 10px;
    }
    .article {
      width: 100%;
      // height: 100%;
      float: left;
      margin-left: 20px;
      font-style: 16px;
      margin-top: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 25px;
    }
  }
  // 下载框
  .dialog {
    border-radius: 20px;
    img {
      width: 300px;
      height: 84px;
      display: block;
      margin: 0 auto;
    }
    div {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      color: #999;
      span {
        font-size: 16px;
        color: #3476C1ff;
        margin: auto 5px;
      }
    }
    div:nth-child(4) {
      color: #000;
      margin-bottom: -15px;
    }

    .el-button {
      width: 80px;
      height: 40px;
      border-radius: 20px;
      margin: 0 25px;
      text-align: center;
    }
    // .dialog-btn{}
    // .dialog{
    //     .el-dialog__header{
    //         padding-top:0px;
    //     }
    // }
  }
}
</style>